import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Badge } from '@/components/ui/badge';

export const SkillsSection = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  const categories = t('skills.categories', { returnObjects: true });
  const skills = t('skills.items', { returnObjects: true });

  const categoryKeys = ['languages', 'frameworks', 'databases', 'tools'];

  return (
    <section
      id="skills"
      data-testid="skills-section"
      ref={ref}
      className="py-16 md:py-24 lg:py-32 px-4 md:px-6 lg:px-8 bg-[#0A0E27]"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-[#F8FAFC] mb-4">
            {t('skills.title')}
          </h2>
          <p className="text-[#CBD5E1] text-lg md:text-xl">
            {t('skills.subtitle')}
          </p>
        </motion.div>

        <div className="space-y-12">
          {categoryKeys.map((categoryKey, categoryIndex) => (
            <motion.div
              key={categoryKey}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: categoryIndex * 0.2 }}
            >
              <h3 className="text-2xl font-semibold text-[#22D3EE] mb-6">
                {categories[categoryKey]}
              </h3>
              <div className="flex flex-wrap gap-3">
                {skills[categoryKey].map((skill, skillIndex) => (
                  <Badge
                    key={skillIndex}
                    data-testid="skill-badge"
                    className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-[#22D3EE]/10 text-[#22D3EE] border border-[#22D3EE]/30 hover:bg-[#22D3EE]/20 hover:border-[#22D3EE]/50 transition-all duration-200 cursor-default"
                  >
                    {skill}
                  </Badge>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
